import { observer } from 'mobx-react'
import { ReactComponent as Heart } from '../../assets/Vector.svg'
import './index.scss'
const Hearts = observer(() => {
  const hearts = (count: number) => {
    return Array(count).fill(0)
  }
  const getClass = (id: number) => {
    const classes = [
      'topright',
      'topleft',
      'bottomright',
      'middlebottomleft',
      'bottomleft',
      'middlebottomright',
      'up',
      'down',
      'middletopleft',
      'right',
      'left',
      'middletopright',
    ]

    return classes[
      id >= classes.length ? Math.floor(id / classes.length) - 1 : id
    ]
  }
  return (
    <span className="hearts">
      {hearts(20).map((h, i) => (
        <Heart key={i} className={getClass(i)} />
      ))}
    </span>
  )
})

export default Hearts
